import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { getUserToken } from "../../utils/Util";
import RentARoomSidebar from "./RentARoomSidebar";
import "../rentaroomstyle.css";

function RentARoomControl({ item }: { item: JSX.Element }) {
  const [collapsed, setCollapsed]   = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile]     = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  if (!getUserToken()) {
    return <Navigate to="/rentaroom" replace />;
  }

  return (
    <div className="rar-layout">
      <RentARoomSidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((c) => !c)}
        isMobile={isMobile}
        drawerOpen={drawerOpen}
        onDrawerClose={() => setDrawerOpen(false)}
      />

      <div className="rar-layout-body">
        {isMobile && (
          <header className="rar-mobile-header">
            <button className="rar-mobile-header-btn menu" onClick={() => setDrawerOpen(true)}>
              <i className="bi bi-list" style={{ fontSize: "1.5rem" }}></i>
            </button>

            <div className="rar-mobile-header-brand">
              <div className="rar-mobile-header-brand-icon">
                <i className="bi bi-building text-white" style={{ fontSize: "0.85rem" }}></i>
              </div>
              <span className="rar-mobile-header-title">RentARoom</span>
            </div>

            <button
              className="rar-mobile-header-btn logout"
              onClick={() => { localStorage.removeItem("user"); navigate("/rentaroom", { replace: true }); }}
            >
              <i className="bi bi-box-arrow-right" style={{ fontSize: "1.3rem" }}></i>
            </button>
          </header>
        )}

        <main className="rar-main">
          {item}
        </main>
      </div>
    </div>
  );
}

export default RentARoomControl;
